import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_PETITION_ACTIVITY = defineFcm('starter_experience_petition_activity')
	.asBoolean()
	.withDefault(false)
	.toConfig();
